import React from 'react'
import { Link } from '@reach/router'
import styled from '@emotion/styled'
/* @jsx jsx */
// eslint-disable-next-line no-unused-vars
import { jsx, css } from '@emotion/core'

const Container = styled.div`
  position: relative;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 2rem;
  font-weight: 100;
  flex-direction: column;
`

const linkStyle = css`
  margin-top: 2rem;
  text-decoration: none;
  color: #275236;
  font-size: 1rem;
`

export default () => (
  <Container>
    <span>Köszönjük megkeresését!</span>
    <Link css={linkStyle} to="/">
      Vissza a főoldalra
    </Link>
  </Container>
)
